export const formDataQueryKeys = {
  _base: () => ["formData"],
  all: (agencyId: string) => [...formDataQueryKeys._base(), { agencyId }],
  single: (agencyId: string, formDataId: string) => [
    ...formDataQueryKeys.all(agencyId),
    "single",
    { formDataId },
  ],
  byPerson: (agencyId: string, personId?: string) => [
    ...formDataQueryKeys.all(agencyId),
    "byPerson",
    { personId },
  ],
};
